import axios from 'axios'
import {services, getHeader} from '@/assets/js/config.js'
import { useAuthStore } from '@/stores/authStore';
import { useConfigStore } from '@/stores/configStore'
import { mapState } from 'pinia'
import _ from 'lodash';

export default {
    computed:{
        ...mapState(useConfigStore, ['app_code']),
        ...mapState(useAuthStore, ['auth_user']),
    },
    methods: {
        // this method resets all the form values except for exclude items
				setLocalStorage(key,data,expired=86400){
					let nextExp = Math.floor(new Date().getTime()/1000.0) + expired;
					let d = {
						data:data,
						exp:nextExp
					}
					window.localStorage.setItem(key,btoa(JSON.stringify(d)));
				},
				getLocalStorage(key){
					let currTime = Math.floor(new Date().getTime()/1000.0);
					let d = window.localStorage.getItem(key);
					// console.log(d);
					if(this.isEmpty(d)) return null;
					d = JSON.parse(atob(d));

					if(d.exp < currTime) return null;
					return d.data;
				},
        resetFormToNull(form, exclude = []) {
            if(form){
                Object.keys(form).forEach(key => {
                    if (typeof form[key] === 'object') {
                        this.resetFormToNull(form[key])
                    } else {
                        if(!exclude.includes(key)){
                            form[key] = '';
                        }
                    }
                });
            }
        },  
        generateFormData(data){
            let formData = new FormData()
            for(let property in data) {
                if(data[property] !== null){
                    if(typeof data[property] === 'object' || Array.isArray(data[property])) {
                        formData.append(property, JSON.stringify(data[property]));
                    }else{
                        formData.append(property, data[property]);
                    }
                }
            }
            return formData
        },
        async getLookupTables(tables){
            try{
                let formData = new FormData()
                formData.append('tables', tables)
                const response = await axios.post(services.lookup + 'tables', formData, { headers: getHeader() })
                return response.data.data
            }catch(e){
                // this.errorFunction(e)
                console.log(e)
            }
        },
        async getUserList(type = null){
            try{
                let url = services.access_control + 'user?corporate_id='+this.auth_user.account_info.corporate_id
                if(type){
                    url = url + '&type='+type
                }
                const response = await axios.get(url, { headers: getHeader() })
                return response.data.data
            }catch(e){
                console.log(e)
            }
        },
        createDownloadFileLink(data, filename){
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.addEventListener('click', () => {
                document.body.removeChild(link);
            });
            document.body.appendChild(link);
            link.click();
        },
        checkRoleExists(user_role_ids, role_ids){
            let has_role = false
            user_role_ids.forEach((role) => {
                if(role_ids.includes(role)){
                    has_role = true
                }
            })
            return has_role
        },
        checkAccess(access_codes){
					let user_access_codes = this.auth_user.access_codes
					if(!user_access_codes) return false;

					let intersect = _.intersection(user_access_codes,access_codes);
					return (intersect.length > 0);
        },
        formatToMoney(number){
            return parseFloat(number).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        },
				formatDate(inputDate, outputFormat="Y-m-d H:i:s") {
					if (inputDate == '' || inputDate === null) return inputDate;

					const date = new Date(inputDate);
					// Check if the date is valid
					if (isNaN(date)) {
						return '';
					}

					const day = String(date.getDate()).padStart(2, '0');
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const year = date.getFullYear();
					const hours = String(date.getHours()).padStart(2, '0');
					const minutes = String(date.getMinutes()).padStart(2, '0');
					const seconds = String(date.getSeconds()).padStart(2, '0');
					//ADD ANOTHER DATE PATERNS

					const patterns = {
						'Y': year,
						'm': month,
						'd': day,
						'H': hours,
						'i': minutes,
						's': seconds,
						//ADD ANOTHER PATERNS
					};

					//ADD ANOTHER PATERNS ON REPLACE REGEX
					return outputFormat.replace(/Y|m|d|H|i|s/g, match => patterns[match] || match);
				},
				formatInitials(name) {
					if(this.isEmpty(name)) return '';
					const names = name.split(' ');
					let initials = '';
					const maxInitials = 3;
					for (let i = 0; i < names.length && i < maxInitials; i++) {
							initials += names[i].charAt(0);
					}
					return initials;
				},
        getCurrentDateTime(include_time = true) {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const hours = String(currentDate.getHours()).padStart(2, '0');
            const minutes = String(currentDate.getMinutes()).padStart(2, '0');
            const seconds = String(currentDate.getSeconds()).padStart(2, '0');
            
            return include_time ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` : `${year}-${month}-${day}`
        },
        copyToClipboard(text){
            const tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
        },
        checkAppCode(app_code){
            return this.app_code.includes(app_code)
        },
        checkRoleType(role_types) {
            return role_types.includes(this.auth_user.account_info.role_type);
        },
        checkAccessCodes(current_user_access, route_required_access){
            if(!current_user_access) return false;
        
            let intersect = _.intersection(current_user_access,route_required_access);
            return (intersect.length > 0);
        },
        checkAppCodeAndRoleType(app_codes, role_types) {
            let has_role = false;
            for (const app_code of app_codes) {
                if (this.app_code.includes(app_code) && role_types.includes(this.auth_user.account_info.role_type)) {
                    has_role = true; // If any app_code matches and role_type is included, return true
                }
            }
            return has_role;
        },
        checkIsCorporateSubscription(){
            return this.auth_user.subscription.privileges.scpk_type.toLowerCase() === 'corporate'
        },
        checkIsCorporatePackageSubscription(){
            return this.auth_user.subscription.privileges.scpk_name.toLowerCase() === 'corporate' || this.auth_user.subscription.privileges.scpk_name.toLowerCase() === 'team'
        },
        isEmpty(param){
						if (param === '' || typeof param === 'undefined' || param === 'null' || param === '[]' || param === '{}' || param === null || ((typeof param === 'object') && (Object.keys(param).length === 0)) ) {
                return true;
            } else {
                return false;
            }
        },
        getUserInitials(name) {
            if(name){
                const names = name.split(' ');
                let initials = '';
                const maxInitials = 3;
                for (let i = 0; i < names.length && i < maxInitials; i++) {
                    initials += names[i].charAt(0);
                }
                return initials;
            }else{
                return name
            }
        }

    }
  }
  